import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import getLoyaltyChooseDoubleRewardsCampaignMetadata from './getLoyaltyChooseDoubleRewardsCampaignMetadata'
import getLoyaltyChooseDoubleRewardsMemberState from './getLoyaltyChooseDoubleRewardsMemberState'
import type { ChooseDoubleRewardsChoice } from '../utils/loyaltyChooseDoubleRewardsState'

function getLoyaltyCanEnrolChooseDoubleRewards(state: App.State, choice?: ChooseDoubleRewardsChoice): boolean {
  const config = getLoyaltyChooseDoubleRewardsCampaignMetadata(state)
  const account = state.loyalty.account
  return !!(
    config && config.endsAt > new Date() &&
    state.auth.account.memberId && getHasLoyaltyAccount(state) &&
    !account.initial && !account.fetching && !account.error &&
    getIsCurrentRegionUserLoyaltyRegion(state) &&
    getLoyaltyChooseDoubleRewardsMemberState(state).status === 'unenrolled' &&
    !(choice === 'statusCredits' && account.data?.tier === 'infinite') &&
    ![config.doublePointsChoiceId, config.doubleStatusCreditsChoiceId].some(id =>
      state.loyalty.earnDecisionEnrolment?.[id]?.fetching || state.loyalty.earnDecisionEnrolment?.[id]?.data,
    )
  )
}

export default getLoyaltyCanEnrolChooseDoubleRewards
